import { isPlannedClosingDateLessThanThirteenDaysAway } from "./isPlannedClosingDateLessThanThirteenDaysAway";

export const isDataValidForRefinance = ({
  amountOfCashOut,
  city,
  county,
  creditScore,
  existingLoanBalance,
  hasWaivedEscrow,
  isSelfEmployed,
  isUsCitizen,
  isVeteran,
  loanOptions,
  occupancyType,
  price,
  propertyType,
  state,
  street,
  zip,
  takeCashOut,
}) => {
  return (
    city &&
    (existingLoanBalance || existingLoanBalance === 0) &&
    (takeCashOut === false || amountOfCashOut) &&
    creditScore &&
    hasWaivedEscrow &&
    occupancyType &&
    (isSelfEmployed || isSelfEmployed === false) &&
    (isUsCitizen || isUsCitizen === false) &&
    (isVeteran || isVeteran === false) &&
    loanOptions &&
    price &&
    propertyType &&
    state &&
    street &&
    zip &&
    county
  );
};
